/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LinkButtonGrey/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function LinkButtonGrey({
  children,
  viewPath = "/DesignSystem/LinkButtonGrey",
  alignItems = "center",
  onClick,
  goTo,
  marginTop = 0,
  marginLeft = 0,
  marginRight = 0,
  paddingTop = 8,
  paddingBottom = 8,
  paddingLeft = 16,
  paddingRight = 16,
  alignSelf = "auto",
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  width = "auto",
  isSelected,
  fontSize = 14,
  text = "Deafult text"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
  data-testid="LinkButtonGrey.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--ai-1-Za5rPo': alignItems,'--mt-2-Za5rPo': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-3-Za5rPo': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-4-Za5rPo': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--pt-5-Za5rPo': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-6-Za5rPo': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-7-Za5rPo': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-8-Za5rPo': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--as-9-Za5rPo': alignSelf,'--bblr-11-Za5rPo': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-12-Za5rPo': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-14-Za5rPo': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-15-Za5rPo': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--w-16-Za5rPo': typeof width === 'number' ? `${width}px` : width,'--bc-10-Za5rPo': isSelected ? "rgba(0,0,0, 0.1)" : isHovered ? "rgba(150,150,150, 0.15)" : "transparent",'--bc-13-Za5rPo': isSelected ? "rgba(0,0,0, 0.1)" : isHovered ? "rgba(0,0,0, 0)" : "#f2f2f2"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="LinkButtonGrey.Text"
  data-view-path={viewPath}
 style={{'--fs-18-Za5rPo': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--c-17-Za5rPo': isSelected ? "rgba(0,0,0, 1)" : isHovered ? "rgba(0,0,0, 1)" : "#303030"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</a>
{children}
</React.Fragment>)
}